
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 100.806 40.327","height":"152.417","width":"381","preserveAspectRatio":"xMinYMax slice"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.024 40.327V11.124l100.782 29.203z","opacity":".25","fill":"#b58a43"}}),_c('path',{attrs:{"d":"M100.806 0v40.322H0z","opacity":".15","fill":"#fff"}})])
          )
        }
      }
    